import { easywayUrl } from '../lib/easyway';

/**
 * Verified Contact Information for Easy Way Rent a Car
 */
export const EASY_WAY_CONTACT = {
  name: 'Easy Way Rent a Car',
  website: easywayUrl('https://easywayrentacar.com/es', 'inicio'),
  websiteEn: easywayUrl('https://easywayrentacar.com/', 'inicio'),
  fleet: easywayUrl('https://easywayrentacar.com/es/cars', 'inicio'),
  fleetEn: easywayUrl('https://easywayrentacar.com/cars', 'inicio'),
  cancunAirport: easywayUrl('https://easywayrentacar.com/es/cancun-airport-car-rental', 'inicio'),
  cancunAirportEn: easywayUrl('https://easywayrentacar.com/cancun-airport-car-rental', 'inicio'),
  playaDelCarmen: easywayUrl('https://easywayrentacar.com/es/car-rental-riviera-maya', 'inicio'),
  playaDelCarmenEn: easywayUrl('https://easywayrentacar.com/car-rental-riviera-maya', 'inicio'),
  contact: easywayUrl('https://easywayrentacar.com/es/contact', 'inicio'),
  contactEn: easywayUrl('https://easywayrentacar.com/contact', 'inicio'),
  getWebsite: (lang: 'es' | 'en' = 'es', pageSlug = 'inicio') =>
    easywayUrl(lang === 'en' ? 'https://easywayrentacar.com/' : 'https://easywayrentacar.com/es', pageSlug),
  getFleetUrl: (lang: 'es' | 'en' = 'es', pageSlug = 'inicio') =>
    easywayUrl(lang === 'en' ? 'https://easywayrentacar.com/cars' : 'https://easywayrentacar.com/es/cars', pageSlug),
  getAirportUrl: (lang: 'es' | 'en' = 'es', pageSlug = 'inicio') =>
    easywayUrl(lang === 'en' ? 'https://easywayrentacar.com/cancun-airport-car-rental' : 'https://easywayrentacar.com/es/cancun-airport-car-rental', pageSlug),
  whatsapp: {
    raw: '5219981255280',
    display: '+52 1 998 125 5280',
    link: 'https://wa.me/5219981255280?text=Hola%20Easy%20Way%2C%20quisiera%20cotizar%20o%20reservar%20un%20auto%20para%20Cancun%20y%20Riviera%20Maya',
    linkEn: 'https://wa.me/5219981255280?text=Hello%20Easy%20Way%2C%20I%20would%20like%20to%20quote%20or%20reserve%20a%20car%20for%20Cancun%20%26%20Riviera%20Maya',
    getLink: (lang: 'es' | 'en' = 'es') =>
      lang === 'en'
        ? 'https://wa.me/5219981255280?text=Hello%20Easy%20Way%2C%20I%20would%20like%20to%20quote%20or%20reserve%20a%20car%20for%20Cancun%20%26%20Riviera%20Maya'
        : 'https://wa.me/5219981255280?text=Hola%20Easy%20Way%2C%20quisiera%20cotizar%20o%20reservar%20un%20auto%20para%20Cancun%20y%20Riviera%20Maya',
    ctaText: 'Chatear por WhatsApp',
    ctaTextEn: 'Chat on WhatsApp',
  },
  phoneMexico: {
    raw: '529988862464',
    display: '+52 998 886 2464',
    link: 'tel:+529988862464',
    label: 'Línea Local México / Cancún',
    labelEn: 'Local Mexico Line / Cancun',
  },
  phoneUsa: {
    raw: '18776403279',
    display: '1-877-640-3279',
    link: 'tel:18776403279',
    label: 'Toll-Free desde EE.UU. & Canadá',
    labelEn: 'Toll-Free USA & Canada',
  },
  email: {
    address: 'easyway@easywayrentacar.com',
    link: 'mailto:easyway@easywayrentacar.com',
    label: 'Correo Electrónico',
    labelEn: 'Email Address',
  },
  offices: [
    'Playa del Carmen (Centro & Entrega en Hoteles)',
    'Aeropuerto Internacional de Cancún (CUN) - Entrega 24/7',
    'Tulum & Riviera Maya'
  ],
  officesEn: [
    'Playa del Carmen (Downtown & Hotel Delivery)',
    'Cancun International Airport (CUN) - 24/7 Delivery',
    'Tulum & Riviera Maya'
  ]
};
